import React from 'react';
export function PaymentMethods() {
  return <div className="w-full space-y-6" data-id="element-76"></div>;
}